export default __webpack_public_path__ + "static/media/AddUser.b5dbf52d.svg";